import * as vp from 'vopay';
import { FunctionComponent, useContext, useMemo } from 'react';
import { DialogueHandler, UpdateGlobalPaymentsDialogueHandler } from './types';
import UpdateGlobalPaymentsCpmtext from './UpdateGlobalPaymentsContext';
import { useTranslation } from 'react-i18next';

const { ConfirmationDialogue } = vp;

type GlobalPaymentsDialogueProps = {
  handleDialogue: DialogueHandler<UpdateGlobalPaymentsDialogueHandler>;
};

type FC = FunctionComponent<GlobalPaymentsDialogueProps>;

const UpdateGlobalPaymentsDialogue: FC = ({ handleDialogue }: GlobalPaymentsDialogueProps) => {
  const { showUpdateSuccessAlert, showUpdateErrorAlert, UpdateError } = useContext(UpdateGlobalPaymentsCpmtext);
  const { t } = useTranslation('translations', { keyPrefix: 'Integrations.GlobalPayments.Dialogs' });

  return useMemo(
    () => (
      <div>
        {/* Update Error */}
        <ConfirmationDialogue
          isVisible={showUpdateErrorAlert}
          title={t('UpdateError.title')}
          status="error"
          subTitle={`${UpdateError}`}
          confirm={{
            label: t('UpdateError.confirmButton'),
            action: () => handleDialogue({ type: 'update', state: 'error' }),
          }}
        />
        {/* Update Success */}
        <ConfirmationDialogue
          isVisible={showUpdateSuccessAlert}
          title={t('UpdateSuccess.title')}
          status="success"
          subTitle={t('UpdateSuccess.subTitle')}
          confirm={{
            label: t('UpdateSuccess.confirmButton'),
            action: () => handleDialogue({ type: 'update', state: 'success' }),
          }}
        />
      </div>
    ),
    [showUpdateSuccessAlert, showUpdateErrorAlert],
  );
};

export default UpdateGlobalPaymentsDialogue;
